// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2QnfT","footer":"ModalInfo_footer__18EnS"};